import React, { useState,useEffect } from "react";
import { Link,useParams} from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { unescapeHtml,isNull,DownloadFile } from "../../components/common/Common";

import fixIcon from "../../img/icon/icon-fix.png";

const NoticeView = () => {
  const { board_idx } = useParams();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varNoticeInfo,setNoticeInfo] = useState({});
  
  //나의 페이지 정보
  const GetNoticeInformation = async() => {
    const sendData = {boardMode:1,board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/parent_get_board_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const noticeData = datas.results[0];
        setNoticeInfo(noticeData);
      } else {
        alert(datas.message);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    GetNoticeInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //첨부파일 다운로드
  const onAttachDownloadHandler = (e) => {
    //const sfolder = varNoticeInfo.board_file.substr(0,6);
    //console.log(`${process.env.REACT_APP_DOWNLOAD_URL}`);
    //const downfile = `${process.env.REACT_APP_DOWNLOAD_URL}/notices/${sfolder}/${varNoticeInfo.board_file}`;
    const downfile = `${process.env.REACT_APP_HOST}/notices/${varNoticeInfo.board_file}`;
    DownloadFile(downfile,varNoticeInfo.board_real_file,2);
  }

  return (
    <div className="vh-content normal-wrap">
      <HeaderUserTitle varPageTitle={'공지사항 상세'} varBackString={'/Parents/Notice'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
          <div className="notice-wrap">
            <div style={{marginTop:"14px",marginBottom:"10px"}}>
              <p style={{fontSize:"13px",color:"#a97752"}}>등록자 : {varNoticeInfo.writerName}</p>
            </div>		
            <div className="top-tit">
							<img src={fixIcon} alt=""/>{unescapeHtml(varNoticeInfo.board_title)}
						</div>	
            <div className="notice-con view">{unescapeHtml(varNoticeInfo.board_comment)}</div>
            {varNoticeInfo.board_attach===0 || isNull(varNoticeInfo.board_file)?null:
              <div className="file-con">
                <p>첨부파일</p>
                <div className="file">
                  <span className="file-name" >{varNoticeInfo.board_real_file}</span> 
                  <button className="file-down" onClick={e=>onAttachDownloadHandler(e)}>다운로드</button>
                </div>
              </div>
            }
          </div>
          <div className="form-contoller bt-btn">
						<Link to={'/Parents/Notice'} className="btn-no">목록</Link>
					</div>
				</div>
      </div>
    </div>
  )
}
export default NoticeView;